export const Selectors = {
	BOOKING_DATEPICKER: '#ig-trialbooking-picker',
	DATEPICKER: '.datepicker',
	DATEPICKER_DAYS: '.datepicker-days',
	APPOINTMENTS: '.appointments',
	BOOKING_FORM: '#booking-form',
	BOOKING_DATE_INPUT: '#booking-date-input',
	BOOKING_DATE_END_INPUT: '#booking-date-end-input'
};

export const Settings = {
	AJAX_TYPE_NUM: 4200
};

export const PluginNames = {
	4200: 'tx_igtrialbooking_booking'
};

export const ResponseCodes = {
	// successfully created booking
	BOOKING_CREATED: 200,
	// booking date was already reserved
	BOOKING_BLOCKED: 300,
	// an appointment with that email was already made on that date
	EMAIL_ALREADY_BOOKED: 301
};
